module.exports = __webpack_public_path__ + "media/ca.ce143108.svg";